export type LoadLaneStatus =
  | 'overdue'
  | 'dueSoon'
  | 'onTime'
  | 'complete'
  | 'vacant';

export type LoadLaneStatusConfig = {
  label: string;
  color: string;
  bg: string;
  border: string;
  dot: string;
  progress: string;
  tabBg: string;
};

export const LOAD_LANE_STATUS_CONFIG: Record<
  LoadLaneStatus,
  LoadLaneStatusConfig
> = {
  overdue: {
    label: 'Overdue',
    color: '#C92A2A',
    bg: '#FEE9E9',
    border: '#F5C6C6',
    dot: '#E03131',
    progress: '#E03131',
    tabBg: '#FCE8E8',
  },
  dueSoon: {
    label: 'Due Soon',
    color: '#D9480F',
    bg: '#FFF9DB',
    border: '#FFC078',
    dot: '#FD7E14',
    progress: '#FD7E14',
    tabBg: '#FFF4E6',
  },
  onTime: {
    label: 'On Time',
    color: '#2B8A3E',
    bg: '#EBFBEE',
    border: '#8CE99A',
    dot: '#37B24D',
    progress: '#37B24D',
    tabBg: '#E6FCF5',
  },
  complete: {
    label: 'Complete',
    color: '#1864AB',
    bg: '#D0EBFF',
    border: '#91C9F9',
    dot: '#339AF0',
    progress: '#339AF0',
    tabBg: '#E7F5FF',
  },
  vacant: {
    label: 'Vacant',
    color: '#868E96',
    bg: '#F1F3F5',
    border: '#DEE2E6',
    dot: '#ADB5BD',
    progress: '#ADB5BD',
    tabBg: '#F1F3F5',
  },
};

export const DUE_SOON_THRESHOLD_MINUTES = 60;

export const STATUS_FILTER_TABS: Array<{
  key: LoadLaneStatus | 'all';
  label: string;
}> = [
  { key: 'all', label: 'All' },
  { key: 'overdue', label: 'Overdue' },
  { key: 'dueSoon', label: 'Due Soon' },
  { key: 'onTime', label: 'On Time' },
  { key: 'vacant', label: 'Vacant' },
  { key: 'complete', label: 'Complete' },
];
